module.exports = __webpack_public_path__ + "static/media/1361_MessageEducation_unread_HL.3320528d.png";